import HeroSection from '../components/HeroSection';
import StatsSection from '../components/StatsSection';
import AppsSection from '../components/AppsSection';

function HomePage() {
  return (
    <>
      <HeroSection />
      <StatsSection />
      <AppsSection />
    </>
  );
}

export default HomePage;
